'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

var processStateInfos = {
    url: '/process/{userAccessRequestID:int}',
    views: {
        'details@userAccessRequest.request': {
            templateUrl: require('./ProcessRequest.tpl.html'),
            controller: 'ProcessRequestController'
        }
    },
    resolve: {
        infosToProcessRequest: ['processAccessRequestService', '$stateParams', function (processAccessRequestService, $stateParams) {
            return processAccessRequestService.getInfosToProcess($stateParams.userAccessRequestID, $stateParams.custodian);
        }],
        custodians: ['businessSystemService', function (service) {
            return service.getAllCustodians();
        }],
        newIamUrl: [function () {
            return environment.iamUrl;
        }]
    }
}

angular.module('userRequestProcessRoutes', ['userRequestProcessControllers',
                                            'services.businessSystem',
                                            'services.processAccessRequest'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state('userAccessRequest.request.all.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.draft.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.underReview.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.pendingAuthorization.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.postDated.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.completed.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.assignedToMe.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.unAssigned.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.toProcess.processRequest', _.clone(processStateInfos))
    .state('userAccessRequest.request.onHold.processRequest', _.clone(processStateInfos))

    .state('userAccessRequest.request.byEmployeeId.processRequest', _.clone(processStateInfos));
}]);
